<template>
  <div
    ref="kt_modal_pedido_receber_editar"
    data-bs-backdrop="static"
    :class="[modal == true ? 'modal fade modal-overlay' : '']"
    tabindex="-1"
    id="kt_modal_pedido_receber_editar"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div v-if="modal === true" class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/ecommerce/ecm002.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Parcelamento / Duplicatas</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelarParcelamento()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div :class="[modal == true ? 'modal-body pt-6 pb-2 px-6' : '']">
          <el-divider content-position="left">Criação das Parcelas</el-divider>
          <div class="d-flex row">
            <div class="col-auto fv-row mb-4">
              <label class="form-label">Qtd Parcelas</label>
              <div class="col">
                <el-input-number
                  :id="`qtdParcelas`"
                  v-model="qtdParcelas"
                  class="w-150px"
                  :min="1"
                  :max="undefined"
                  size="large"
                  controls-position="right"
                  @focus="onFocus($event.target.id)"
                  v-on:keyup.enter="nextFocus(`intervaloDias`)"
                />
                <div
                  v-if="getErrorByID(`qtdParcelas`)"
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{ getErrorByID(`qtdParcelas`) }}
                </div>
              </div>
            </div>
            <div class="col-auto fv-row mb-4">
              <label class="form-label">Intervalo / Dias</label>
              <div class="col">
                <el-input-number
                  :id="`intervaloDias`"
                  v-model="intervaloDias"
                  class="w-150px"
                  :min="0"
                  :max="undefined"
                  size="large"
                  controls-position="right"
                  @focus="onFocus($event.target.id)"
                  v-on:keyup.enter="nextFocus(`especie`)"
                />
                <div
                  v-if="getErrorByID(`intervaloDias`)"
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{ getErrorByID(`intervaloDias`) }}
                </div>
              </div>
            </div>
            <div class="col-auto fv-row mb-4">
              <label class="form-label">Conta</label>
              <div
                :class="[getErrorByID(`planoConta`) ? 'w-175px' : 'w-125px']"
                class="input-group"
              >
                <input
                  :id="`planoConta`"
                  type="text"
                  class="form-control"
                  :class="[getErrorByID(`planoConta`) ? 'is-invalid' : '']"
                  v-model="planoConta"
                  readonly
                />
                <button
                  class="input-group-text"
                  @click="this.modalContas(true)"
                >
                  <span class="svg-icon svg-icon-2">
                    <inline-svg src="media/icons/duotune/general/gen004.svg" />
                  </span>
                </button>
              </div>
              <div
                v-if="getErrorByID(`planoConta`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`planoConta`) }}
              </div>
            </div>
            <div class="col-auto fv-row mb-4">
              <label class="form-label">Custo</label>
              <div
                :class="[getErrorByID(`centroCusto`) ? 'w-175px' : 'w-125px']"
                class="input-group"
              >
                <input
                  :id="`centroCusto`"
                  type="text"
                  class="form-control"
                  :class="[getErrorByID(`centroCusto`) ? 'is-invalid' : '']"
                  v-model="centroCusto"
                  readonly
                />
                <button
                  class="input-group-text"
                  @click="this.modalCustos(true)"
                >
                  <span class="svg-icon svg-icon-2">
                    <inline-svg src="media/icons/duotune/general/gen004.svg" />
                  </span>
                </button>
              </div>
              <div
                v-if="getErrorByID(`centroCusto`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`centroCusto`) }}
              </div>
            </div>
            <div class="col-auto fv-row mb-4">
              <label class="form-label">Banco</label>
              <div
                :class="[getErrorByID(`banco`) ? 'w-175px' : 'w-125px']"
                class="input-group"
              >
                <input
                  :id="`banco`"
                  type="text"
                  class="form-control"
                  :class="[getErrorByID(`banco`) ? 'is-invalid' : '']"
                  v-model="banco"
                  readonly
                />
                <button class="input-group-text">
                  <span class="svg-icon svg-icon-2">
                    <inline-svg src="media/icons/duotune/general/gen004.svg" />
                  </span>
                </button>
              </div>
              <div
                v-if="getErrorByID(`banco`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`banco`) }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="d-flex align-self-end mb-7 mb-lg-10 col-auto">
              <div class="form-check form-check-custom form-check-sm">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="ckEntrada"
                  id="ckEntrada"
                  tabindex="-1"
                  @change="atualizarCheckbox($event.target)"
                />
                <label class="form-check-label pt-2" for="ckEntrada">
                  <h6>1ª Entrada</h6>
                </label>
              </div>
            </div>
            <div class="col-auto fv-row mb-4 ms-10 d-flex align-items-center">
              <div class="row">
                <div
                  class="col-1 fv-row d-flex justify-content-end align-items-end p-0 mb-3"
                >
                  <span class="svg-icon svg-icon-2qx"
                    ><inline-svg :src="getEspeciePagamento(cod_especie)"
                  /></span>
                </div>
                <div class="col-11 fv-row">
                  <label class="form-label fw-bold fs-6">Espécie</label>
                  <select
                    class="form-select"
                    :id="`especie`"
                    :class="[getErrorByID(`especie`) ? 'is-invalid' : '']"
                    v-model="especie"
                    @change="atualizarEspeciePagamento($event.target.value)"
                  >
                    <option
                      v-for="forma in formasPagamento"
                      v-bind:key="forma.descricao"
                      v-bind:value="forma.descricao"
                    >
                      {{ forma.descricao }}
                    </option>
                  </select>
                  <div
                    v-if="getErrorByID(`especie`)"
                    class="fv-plugins-message-container invalid-feedback"
                  >
                    {{ getErrorByID(`especie`) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-self-end mb-7 flex-column col-auto">
              <div class="form-check form-check-custom form-check-sm">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="ckDiaAcerto"
                  id="ckDiaAcerto"
                  tabindex="-1"
                  @change="atualizarCheckbox($event.target)"
                />
                <label class="form-check-label pt-2" for="ckDiaAcerto">
                  <h6>Usa Dia de Acerto</h6>
                </label>
              </div>
              <div class="form-check form-check-custom form-check-sm">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="ckUsaCondicoes"
                  id="ckUsaCondicoes"
                  tabindex="-1"
                  @change="atualizarCheckbox($event.target)"
                />
                <label class="form-check-label pt-2" for="ckUsaCondicoes">
                  <h6>Usa Condições</h6>
                </label>
              </div>
            </div>
            <div class="col-auto ms-auto mb-4">
              <div class="d-flex flex-column">
                <button
                  id="btnCriarParcelas"
                  @click="criarParcelas()"
                  class="btn btn-light-success mb-2"
                >
                  <i class="la la-plus me-2 fs-3"></i>Criar parcelas
                </button>

                <button @click="removerParcelas()" class="btn btn-light-danger">
                  <i class="la la-trash-o p-0 fs-1 me-2"></i>
                  Limpar parcelas
                </button>
              </div>
            </div>
          </div>
          <div v-if="ckUsaCondicoes" class="row">
            <div class="col-12 fv-row mb-4">
              <label class="form-label">Condição pré-definida</label>
              <div class="input-group">
                <input
                  :id="`condicoes`"
                  type="text"
                  class="form-control"
                  :class="[getErrorByID(`condicoes`) ? 'is-invalid' : '']"
                  v-model="condicao.condicoes"
                  readonly
                />
                <button
                  class="input-group-text"
                  @click="this.modalCondicoes(true)"
                >
                  <span class="svg-icon svg-icon-2">
                    <inline-svg src="media/icons/duotune/general/gen004.svg" />
                  </span>
                </button>
              </div>
              <div class="row">
                <div class="col-6 pe-0">
                  <div
                    v-if="getErrorByID(`condicoes`)"
                    class="fv-plugins-message-container invalid-feedback"
                  >
                    {{ getErrorByID(`condicoes`) }}
                  </div>
                </div>
                <div class="col-6 ps-2">
                  <div class="text-end text-muted fs-7">
                    Selecione uma condição
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-divider content-position="left">Parcelas</el-divider>
          <Datatable
            ref="table"
            :table-header="this.tableParcelamentoHeader"
            :table-data="this.pedidoReceber"
            :loading="this.loadingParcelamento"
            :emptyTableText="'Nenhuma parcela foi adicionada'"
            :rowsPerPage="1000"
            :enableItemsPerPageDropdown="false"
          >
            <template
              v-slot:cell-ordem="{ row: pedidoReceber, position: index }"
            >
              <div
                :id="`PedidoReceber[${index}]ordem`"
                tabindex="0"
                :class="[
                  getErrorByID(`PedidoReceber[${index}]ordem`)
                    ? 'min-w-100px'
                    : '',
                ]"
                class="text-center"
              >
                {{ pedidoReceber.ordem }}
              </div>
              <div
                v-if="getErrorByID(`PedidoReceber[${index}]ordem`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`PedidoReceber[${index}]ordem`) }}
              </div>
            </template>
            <template v-slot:cell-vencimento="{ position: index }">
              <div
                :class="[
                  getErrorByID(`PedidoReceber[${index}]vencimento`)
                    ? 'mw-200px'
                    : 'mw-150px',
                ]"
              >
                <el-date-picker
                  :id="`PedidoReceber[${index}]vencimento`"
                  v-model="this.pedidoReceber[index].vencimento"
                  type="datetime"
                  name="dtpVencimento"
                  placeholder="Vencimento"
                  format="DD/MM/YYYY"
                  size="large"
                />
              </div>
              <div
                v-if="getErrorByID(`PedidoReceber[${index}]vencimento`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`PedidoReceber[${index}]vencimento`) }}
              </div>
            </template>
            <template v-slot:cell-valor="{ position: index }">
              <FocusCurrencyInput
                :id="`PedidoReceber[${index}]valor`"
                :class="[
                  getErrorByID(`PedidoReceber[${index}]valor`)
                    ? 'min-w-100px'
                    : 'min-w-60px',
                ]"
                :hasError="
                  getErrorByID(`PedidoReceber[${index}]valor`) ? true : false
                "
                placeholder="Valor"
                v-model="this.pedidoReceber[index].valor"
                :options="options"
                style="text-align: center"
                v-on:keyup.enter="atualizarParcelas(index)"
              ></FocusCurrencyInput>
              <div
                v-if="getErrorByID(`PedidoReceber[${index}]valor`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`PedidoReceber[${index}]valor`) }}
              </div>
            </template>
            <template v-slot:cell-especie="{ position: index }">
              <div
                :class="[
                  getErrorByID(`PedidoReceber[${index}]especie`)
                    ? 'min-w-225px'
                    : 'min-w-175px',
                ]"
              >
                <select
                  :id="`PedidoReceber[${index}]especie`"
                  class="form-select"
                  :class="[
                    getErrorByID(`PedidoReceber[${index}]especie`)
                      ? 'is-invalid'
                      : '',
                  ]"
                  v-model="this.pedidoReceber[index].especie"
                >
                  <option
                    v-for="forma in formasPagamento"
                    v-bind:key="forma.descricao"
                    v-bind:value="forma.descricao"
                  >
                    {{ forma.descricao }}
                  </option>
                </select>
                <div
                  v-if="getErrorByID(`PedidoReceber[${index}]especie`)"
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{ getErrorByID(`PedidoReceber[${index}]especie`) }}
                </div>
              </div>
            </template>
            <template v-slot:cell-banco="{ position: index }">
              <div
                :class="[
                  getErrorByID(`PedidoReceber[${index}]banco`)
                    ? 'min-w-125px'
                    : 'min-w-75px',
                ]"
              >
                <select
                  :id="`PedidoReceber[${index}]banco`"
                  class="form-select"
                  :class="[
                    getErrorByID(`PedidoReceber[${index}]banco`)
                      ? 'is-invalid'
                      : '',
                  ]"
                  v-model="this.pedidoReceber[index].banco"
                ></select>
                <div
                  v-if="getErrorByID(`PedidoReceber[${index}]banco`)"
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{ getErrorByID(`PedidoReceber[${index}]banco`) }}
                </div>
              </div>
            </template>
            <template v-slot:cell-entrada="{ position: index }">
              <div
                class="form-check form-check-custom form-check-sm d-flex justify-content-center"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  @change="onCheckedEntrada($event.target.checked, index)"
                  :checked="
                    this.pedidoReceber[index].recebimento ? true : false
                  "
                />
              </div>
            </template>
          </Datatable>
          <el-divider
            v-if="modal === true"
            class="my-15"
            content-position="right"
          >
            <div
              v-if="modal === true"
              class="bg-light-danger rounded border-dark border-1 border py-2 px-3"
            >
              Valor total do pedido
              <div class="text-danger text-end fs-3">
                R$ {{ this.$utils.formatarNumero(this.pedido.total) }}
              </div>
            </div></el-divider
          >
        </div>
        <div
          v-if="modal === true"
          class="modal-footer d-flex justify-content-end"
        >
          <button
            id="btnConfirmar"
            class="btn btn-success svg-icon-white mb-2"
            @click="confirmarParcelamento()"
            v-bind:data-kt-indicator="this.loadingParcelamento ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loadingParcelamento">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <ContasModal
    v-if="exibirContas"
    @exibirModalContas="modalContas"
    @selecionarConta="selecionarConta"
  ></ContasModal>
  <CustosModal
    v-if="exibirCustos"
    @exibirModalCustos="modalCustos"
    @selecionarCusto="selecionarCusto"
  ></CustosModal>
  <CondicoesModal
    v-if="exibirCondicoes"
    @exibirModalCondicoes="modalCondicoes"
    @selecionarCondicao="selecionarCondicao"
  ></CondicoesModal>
</template>

<script>
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import FocusCurrencyInput from "@/components/text/FocusCurrencyInput";
import ContasModal from "@/views/contas/ContasModal.vue";
import CustosModal from "@/views/custos/CustosModal.vue";
import CondicoesModal from "@/views/condicoes/CondicoesModal.vue";
import { hideModal, getOrCreateInstanceModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useToast } from "vue-toastification";
import _ from "lodash";
const toast = useToast();

export default {
  emits: [
    "exibirModalPedidoReceber",
    "confirmarParcelamento",
    "update:errosValidacaoGeral",
    "update:errosValidacao",
  ],
  components: {
    Datatable,
    FocusCurrencyInput,
    ContasModal,
    CustosModal,
    CondicoesModal,
  },
  props: {
    pedido: { type: Object, required: true },
    modal: { type: Boolean, required: true },
    errosValidacao: { type: Object, required: false },
    errosValidacaoGeral: { type: Object, required: false },
  },
  methods: {
    async showInvalidAlert(text) {
      await Swal.fire({
        text: text,
        icon: "warning",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-warning",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    handleEnterKey(event) {
      if (event.key === "Enter") {
        const confirmButton = document.querySelector(".swal2-confirm");
        if (confirmButton) {
          confirmButton.click();
        }
      } else if (event.key === "Escape") {
        const cancelButton = document.querySelector(".swal2-cancel");
        if (cancelButton) {
          cancelButton.click();
        }
      }
    },
    getErrorByID(id) {
      return this.errosValidacao[id] &&
        this.errosValidacao[id] !== undefined &&
        this.errosValidacao[id] !== ""
        ? this.errosValidacao[id]
        : null;
    },
    modalCondicoes(exibir) {
      this.exibirCondicoes = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_condicoes_consultar");
        }, 100);
      }
    },
    selecionarCondicao(condicao) {
      this.condicao.condicoes = condicao.condicoes;
      this.condicao.id_condicao = condicao.id;
    },
    selecionarCusto(custo) {
      this.centroCusto = custo.id;
    },
    modalCustos(exibir) {
      this.exibirCustos = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_custos_consultar");
        }, 100);
      }
    },
    selecionarConta(conta) {
      this.planoConta = conta.id;
    },
    modalContas(exibir) {
      this.exibirContas = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_contas_consultar");
        }, 100);
      }
    },
    onFocus(id) {
      document.getElementById(id).select();
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    atualizarCheckbox(element) {
      if (element.id === "ckUsaCondicoes" && element.checked === true) {
        this.ckEntrada = false;
        this.ckDiaAcerto = false;
      }

      if (element.id === "ckDiaAcerto" && element.checked === true) {
        this.ckUsaCondicoes = false;
      }

      if (element.id === "ckEntrada" && element.checked === true) {
        this.ckUsaCondicoes = false;
      }
    },
    confirmarParcelamento() {
      this.loadingParcelamento = true;
      if (this.ckUsaCondicoes === true) {
        this.$emit("confirmarParcelamento", this.condicao);
      } else {
        this.$emit("confirmarParcelamento", null);
      }
      hideModal(this.$refs.kt_modal_pedido_receber_editar);
      this.$emit("exibirModalPedidoReceber", false);
      this.loadingParcelamento = false;
    },
    cancelarParcelamento() {
      hideModal(this.$refs.kt_modal_pedido_receber_editar);
      this.$emit("exibirModalPedidoReceber", false);
    },
    atualizarParcelas(index) {
      if (this.pedidoReceber[index].recebimento !== null) {
        this.pedidoReceber[index].valor_recebido =
          this.pedidoReceber[index].valor;
        this.pedidoReceber[index].recebimento = new Date(
          this.pedido.data_emissao
        );
      }

      var somaParcelas = 0;
      var valorAtualizar = 0;
      var qtdParcelasAtualizar = 0;
      for (var i = 0; i <= index; i++) {
        somaParcelas += this.pedidoReceber[i].valor;
      }

      for (var y = index + 1; y < this.pedidoReceber.length; y++) {
        qtdParcelasAtualizar += 1;
      }

      valorAtualizar = this.pedido.total - somaParcelas;
      valorAtualizar = _.round(valorAtualizar / qtdParcelasAtualizar, 2);

      for (var z = index + 1; z < this.pedidoReceber.length; z++) {
        this.pedidoReceber[z].valor = valorAtualizar;

        if (this.pedidoReceber[z].recebimento !== null) {
          this.pedidoReceber[z].valor_recebido = valorAtualizar;
          this.pedidoReceber[z].recebimento = new Date(
            this.pedido.data_emissao
          );
        }
      }

      this.ajustarDiferencaValorParcela();
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async criarParcelas() {
      this.limparErrosValidacao();

      if ((await this.validar()) === true) {
        this.loadingParcelamento = true;
        await this.sleep(100);

        var valorParcela = _.round(this.pedido.total / this.qtdParcelas, 2);

        var parcelamento = {
          id: 0,
          id_pedido: 0,
          documento: "",
          ordem: 1,
          emissao: null,
          conta: null,
          custo: null,
          descricao: "",
          vencimento: null,
          recebimento: null,
          valor: 0,
          valor_recebido: 0,
          cod_especie: "",
          especie: "",
          juros: 0,
          juros_reais: 0,
          modelo: "",
          serie: "",
          banco: null,
          nosso_numero: "",
          guid: "",
        };

        if (this.ckUsaCondicoes === true) {
          parcelamento.documento = this.pedido.id.toString().padStart(10, "0");
          parcelamento.emissao = new Date(this.pedido.data_emissao);
          parcelamento.conta = this.planoConta;
          parcelamento.custo = this.centroCusto;
          parcelamento.modelo = "00";
          parcelamento.serie = "000";
          parcelamento.especie = this.especie;
          parcelamento.valor = this.pedido.total;
          parcelamento.juros = 0;
          parcelamento.juros_reais = 0;
          parcelamento.condicoes = this.condicao.condicoes;

          if (this.especie.toUpperCase().includes("BOLETO")) {
            parcelamento.banco = this.banco;
          } else {
            parcelamento.banco = "";
          }

          await this.inserirParcelaCondicoes(parcelamento);
          await this.verificaModal();
        } else if (this.ckDiaAcerto === true) {
          var diaAcerto = this.pedido.PedidoCliente.Cliente.dia_acerto;

          parcelamento.qtdParcelas = this.qtdParcelas;
          parcelamento.diasIntervalo = 31;
          parcelamento.documento = this.pedido.id.toString().padStart(10, "0");
          parcelamento.emissao = new Date(this.pedido.data_emissao);
          parcelamento.conta = this.planoConta;
          parcelamento.custo = this.centroCusto;
          parcelamento.modelo = "00";
          parcelamento.serie = "000";
          parcelamento.especie = this.especie;
          parcelamento.valor = valorParcela;
          parcelamento.diaAcerto = diaAcerto;
          parcelamento.juros = 0;
          parcelamento.juros_reais = 0;

          if (this.ckEntrada === true) {
            parcelamento.primeiraEntrada = true;
          } else {
            parcelamento.primeiraEntrada = false;
          }

          if (this.especie.toUpperCase().includes("BOLETO")) {
            parcelamento.banco = this.banco;
          } else {
            parcelamento.banco = "";
          }

          await this.inserirParcelaDiaAcerto(parcelamento);
          await this.verificaModal();
        } else {
          parcelamento.qtdParcelas = this.qtdParcelas;
          parcelamento.diasIntervalo = this.intervaloDias;
          parcelamento.documento = this.pedido.id.toString().padStart(10, "0");
          parcelamento.emissao = new Date(this.pedido.data_emissao);
          parcelamento.conta = this.planoConta;
          parcelamento.custo = this.centroCusto;
          parcelamento.modelo = "00";
          parcelamento.serie = "000";
          parcelamento.especie = this.especie;
          parcelamento.valor = valorParcela;
          parcelamento.juros = 0;
          parcelamento.juros_reais = 0;

          if (this.ckEntrada === true) {
            parcelamento.primeiraEntrada = true;
          } else {
            parcelamento.primeiraEntrada = false;
          }

          if (this.especie.toUpperCase().includes("BOLETO")) {
            parcelamento.banco = this.banco;
          } else {
            parcelamento.banco = "";
          }

          await this.inserirParcela(parcelamento);
          await this.verificaModal();
        }
      } else {
        await this.showInvalidAlert("Verifique os avisos!");
      }
    },
    async verificaModal() {
      await this.ajustarDiferencaValorParcela();
      if (this.modal === false) {
        if (this.ckUsaCondicoes === true) {
          this.$emit("confirmarParcelamento", this.condicao);
        } else {
          this.$emit("confirmarParcelamento", null);
        }
      } else {
        this.nextFocus("btnConfirmar");
      }
      this.loadingParcelamento = false;
    },
    async validar() {
      let result = true;

      if (this.pedido.total === 0) {
        this.atualizarErrosValidacao(
          `total`,
          "O total do pedido está com valor zerado",
          "tabPagamento",
          "kt_pedido_pagamento"
        );
        result = false;
      }

      if (!this.$utils.isInteger(this.qtdParcelas)) {
        this.atualizarErrosValidacao(
          `qtdParcelas`,
          "A quantidade de parcelas é inválida",
          "tabPagamento",
          "kt_pedido_pagamento"
        );
        result = false;
      }

      if (!this.$utils.isInteger(this.intervaloDias)) {
        this.atualizarErrosValidacao(
          `intervaloDias`,
          "O intervalo de dias é inválido",
          "tabPagamento",
          "kt_pedido_pagamento"
        );
        result = false;
      }

      if (this.ckDiaAcerto === true) {
        var diaAcerto = this.pedido.PedidoCliente.Cliente.dia_acerto;
        if (
          !this.$utils.isInteger(diaAcerto) ||
          !(diaAcerto >= 1 && diaAcerto <= 31)
        ) {
          this.atualizarErrosValidacao(
            `PedidoClientenome`,
            "O dia de acerto do cliente selecionado é inválido",
            "tabGeral",
            "kt_pedido_geral"
          );
          result = false;
        }
      }

      if (this.ckUsaCondicoes === true && this.condicao.condicoes === "") {
        this.atualizarErrosValidacao(
          `condicoes`,
          "A condição de pagamento é inválida",
          "tabPagamento",
          "kt_pedido_pagamento"
        );
        result = false;
      }

      return result;
    },
    limparErrosValidacao() {
      var validacao = this.errosValidacao;
      Object.keys(validacao).forEach((key) => delete validacao[key]);
      this.$emit("update:errosValidacao", validacao);
      var validacaoGeral = this.errosValidacaoGeral;
      validacaoGeral.splice(0);
      this.$emit("update:errosValidacaoGeral", validacaoGeral);
    },
    atualizarErrosValidacao(id, error, idTab, idPage) {
      var validacao = this.errosValidacao;
      validacao[id] = error;
      this.$emit("update:errosValidacao", validacao);
      var validacaoGeral = this.errosValidacaoGeral;
      validacaoGeral.push({
        error: this.getErrorByID(id),
        elemento: id,
        tab: idTab,
        tabID: idPage,
      });
      this.$emit("update:errosValidacaoGeral", validacaoGeral);
    },
    ajustarDiferencaValorParcela() {
      var somaParcelas = 0;
      var diferencaParcelas = 0;
      var indexUltimaParcela = this.pedidoReceber.length - 1;
      for (var i = 0; i < this.pedidoReceber.length; i++) {
        somaParcelas += this.pedidoReceber[i].valor;
      }

      diferencaParcelas = this.pedido.total - somaParcelas;
      this.pedidoReceber[indexUltimaParcela].valor =
        this.pedidoReceber[indexUltimaParcela].valor + diferencaParcelas;

      if (this.pedidoReceber[indexUltimaParcela].recebimento !== null) {
        this.pedidoReceber[indexUltimaParcela].valor_recebido =
          this.pedidoReceber[indexUltimaParcela].valor;
        this.pedidoReceber[indexUltimaParcela].recebimento = new Date(
          this.pedido.data_emissao
        );
      }
    },
    async inserirParcelaCondicoes(p) {
      await this.limparParcelas();
      var parcela = 0;

      p.qtdParcelas = p.condicoes.trim().split("/").length - 1;

      p.valor = p.valor / p.qtdParcelas;

      for (var i = 0; i < p.qtdParcelas; i++) {
        parcela = parcela + 1;
        p.vencimento = new Date(
          p.emissao.getTime() +
            p.condicoes.trim().split("/")[i] * 24 * 60 * 60 * 1000
        );

        p.ordem = parcela;
        p.descricao =
          parcela + "ª Parcela referente ao pedido: " + this.pedido.id;
        p.recebimento = null;
        p.valor_recebido = 0;
        p.guid = this.$utils.generateUuidv4();
        this.pedidoReceber.push(JSON.parse(JSON.stringify(p)));
      }
    },
    async inserirParcelaDiaAcerto(p) {
      await this.limparParcelas();
      var parcela = 0;
      var dataVencimento = p.emissao;

      for (var i = 0; i < p.qtdParcelas; i++) {
        parcela = parcela + 1;

        p.ordem = parcela;
        p.descricao =
          parcela + "ª Parcela referente ao pedido: " + this.pedido.id;

        if (parcela === 1 && p.primeiraEntrada === true) {
          p.vencimento = p.emissao;
          p.recebimento = p.emissao;
          p.valor_recebido = p.valor;
        } else {
          dataVencimento = new Date(
            dataVencimento.getTime() + p.diasIntervalo * 24 * 60 * 60 * 1000
          );

          var dataGerada = new Date(dataVencimento);
          dataGerada = new Date(
            dataGerada.getFullYear(),
            dataGerada.getMonth(),
            p.diaAcerto
          );
          if (dataGerada.getDate() !== p.diaAcerto) {
            dataGerada = new Date(dataVencimento);
            if (dataGerada.getMonth() === 1) {
              dataGerada = new Date(
                dataGerada.getFullYear(),
                dataGerada.getMonth(),
                28
              );
            } else {
              dataGerada = new Date(
                dataGerada.getFullYear(),
                dataGerada.getMonth(),
                p.diaAcerto - 1
              );
            }
          }

          p.vencimento = dataGerada;
          p.recebimento = null;
          p.valor_recebido = 0;
        }

        p.guid = this.$utils.generateUuidv4();
        this.pedidoReceber.push(JSON.parse(JSON.stringify(p)));
      }
    },
    async inserirParcela(p) {
      await this.limparParcelas();
      var parcela = 0;
      var dataVencimento = p.emissao;

      for (var i = 0; i < p.qtdParcelas; i++) {
        parcela = parcela + 1;

        p.ordem = parcela;
        p.descricao =
          parcela + "ª Parcela referente ao pedido: " + this.pedido.id;

        if (parcela === 1 && p.primeiraEntrada === true) {
          p.vencimento = p.emissao;
          p.recebimento = p.emissao;
          p.valor_recebido = p.valor;
        } else {
          dataVencimento = new Date(
            dataVencimento.getTime() + p.diasIntervalo * 24 * 60 * 60 * 1000
          );

          p.vencimento = dataVencimento;
          p.recebimento = null;
          p.valor_recebido = 0;
        }

        p.guid = this.$utils.generateUuidv4();
        this.pedidoReceber.push(JSON.parse(JSON.stringify(p)));
      }
    },
    async removerParcelas() {
      this.loadingParcelamento = true;
      if (this.pedidoReceber.length > 0) {
        var alert = await Swal.fire({
          text: "Deseja remover as parcelas criadas?",
          icon: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sim, remova!",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn fw-bold btn-primary",
            cancelButton: "btn fw-bold btn-danger",
          },
        });
        if (alert.isConfirmed) {
          await this.limparParcelas();
        }
      }
      this.loadingParcelamento = false;
    },
    async limparParcelas() {
      this.pedidoReceber.splice(0, this.pedidoReceber.length, ...[]);
    },
    onCheckedEntrada(checked, index) {
      if (checked === true) {
        this.pedidoReceber[index].recebimento = this.pedido.data_emissao;
        this.pedidoReceber[index].vencimento = this.pedido.data_emissao;
        this.pedidoReceber[index].valor_recebido =
          this.pedidoReceber[index].valor;
      } else {
        this.pedidoReceber[index].recebimento = null;
        this.pedidoReceber[index].valor_recebido = 0;
      }
    },
    atualizarEspeciePagamento(descricao) {
      this.formasPagamento.find((element) => {
        if (element.descricao === descricao) {
          this.cod_especie = element.cod_especie;
        }
      });
    },
    getEspeciePagamento(cod_especie) {
      for (var i = 0; i < this.formasPagamento.length; i++) {
        if (this.formasPagamento[i].cod_especie === cod_especie) {
          return this.formasPagamento[i].icon;
        }
      }
    },
  },
  mounted() {
    if (this.pedido.id_condicao !== null) {
      this.ckUsaCondicoes = true;
      this.condicao.condicoes = this.pedido.Condicao.condicoes;
      this.condicao.id_condicao = this.pedido.id_condicao;
    }
    if (this.modal == true) {
      setTimeout(() => {
        this.nextFocus("qtdParcelas");
      }, 800);
    }
  },
  data() {
    return {
      timeOut: null,
      exibirCustos: false,
      exibirContas: false,
      exibirCondicoes: false,
      qtdParcelas: 1,
      intervaloDias: 30,
      planoConta: null,
      centroCusto: null,
      banco: null,
      ckEntrada: false,
      ckDiaAcerto: false,
      ckUsaCondicoes: false,
      cod_especie: "1",
      especie: "Dinheiro",
      loadingParcelamento: false,
      pedidoReceber: this.pedido.PedidoReceber,
      condicao: {
        condicoes: "",
        id_condicao: 0,
      },
      formasPagamento: [
        {
          cod_especie: "1",
          descricao: "Dinheiro",
          icon: "media/icons/duotune/finance/fin003.svg",
        },
        {
          cod_especie: "2",
          descricao: "Cheque",
          icon: "media/icons/duotune/files/fil003.svg",
        },
        {
          cod_especie: "3",
          descricao: "Cartão de Crédito",
          icon: "media/icons/duotune/finance/fin002.svg",
        },
        {
          cod_especie: "4",
          descricao: "Cartão de Débito",
          icon: "media/icons/duotune/finance/fin002.svg",
        },
        {
          cod_especie: "5",
          descricao: "Crédito Loja",
          icon: "media/icons/duotune/coding/cod002.svg",
        },
        {
          cod_especie: "5",
          descricao: "A PRAZO",
          icon: "media/icons/duotune/coding/cod002.svg",
        },
        {
          cod_especie: "5",
          descricao: "Convênio",
          icon: "media/icons/duotune/coding/cod002.svg",
        },
        {
          cod_especie: "5",
          descricao: "T.E.F",
          icon: "media/icons/duotune/coding/cod002.svg",
        },
        {
          cod_especie: "10",
          descricao: "Vale Alimentação",
          icon: "media/icons/duotune/ecommerce/ecm011.svg",
        },
        {
          cod_especie: "11",
          descricao: "Vale Refeição",
          icon: "media/icons/duotune/ecommerce/ecm011.svg",
        },
        {
          cod_especie: "12",
          descricao: "Vale Presente",
          icon: "media/icons/duotune/ecommerce/ecm011.svg",
        },
        {
          cod_especie: "13",
          descricao: "Vale Combustível",
          icon: "media/icons/duotune/ecommerce/ecm011.svg",
        },
        {
          cod_especie: "17",
          descricao: "PIX",
          icon: "media/icons/duotune/finance/fin010.svg",
        },
        {
          cod_especie: "99",
          descricao: "Outros",
          icon: "media/icons/duotune/finance/fin008.svg",
        },
      ],
      tableParcelamentoHeader: [
        {
          name: "Ordem",
          key: "ordem",
          sortable: true,
        },
        {
          name: "Vencimento",
          key: "vencimento",
          sortable: true,
        },
        {
          name: "Valor",
          key: "valor",
          sortable: true,
        },
        {
          name: "Espécie",
          key: "especie",
          sortable: true,
        },
        {
          name: "Banco",
          key: "banco",
          sortable: true,
        },
        {
          name: "Entrada",
          key: "entrada",
          sortable: false,
          text: "center",
        },
      ],
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style></style>
